import React from "react";
import blog1 from "../../resources/blog1.png";
import blog2 from "../../resources/blog2.png";
import blog3 from "../../resources/blog3.png";
import Blog from "./Blog/Blog";
import "./HomeSectionFive.css";

const blogs = [
  {
    title: "7 reasons why you should accept Guest Post",
    subtitle:
      "So you have a well-built website, adopted fair promotional strategies..",
    img: blog1,
  },
  {
    title: "Why Guest Blogging Is One Of The Best Link Building",
    subtitle:
      "The world has gone digital, and businesses of all sizes are going..",
    img: blog2,
  },
  {
    title: "How do you Value a Business? - Valued Accountancy",
    subtitle:
      "So you have a well-built website, adopted fair promotional strategies..",
    img: blog3,
  },
];

function HomeSectionFive() {
  return (
    <div className="homeSectionFive">
      <div className="homeSectionFive__one">
        <div className="homeSectionFive__one--heading">
          <h2>Recent Blogs</h2>
        </div>
        <span className="homeSectionFive__one-dash"></span>
        <div className="homeSectionFive__one--p">
          <p>
            Lorem Ipsum has been the industry's standard dummy text ever since
          </p>
        </div>
      </div>

      <div className="homeSectionFive__two">
        <div className="homeSectionFive__two--blogs">
          {blogs.map(({ title, subtitle, img }) => {
            return <Blog title={title} subtitle={subtitle} img={img} />;
          })}
        </div>
      </div>
    </div>
  );
}

export default HomeSectionFive;
